import React from "react";
import {
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  Box,
  useTheme,
  useMediaQuery,
  Avatar,
  Menu,
  MenuItem,
  Divider,
} from "@mui/material";
import {
  Menu as MenuIcon,
  Brightness4,
  Brightness7,
} from "@mui/icons-material";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { LanguageSelector } from "../LanguageSelector";

const Header = ({ onMenuClick, sidebarWidth = 240, setCollapsed }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const dispatch = useDispatch();
  const { isDarkMode } = useSelector((state) => state.theme);
  const user = useSelector((state) => state.auth.user);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const navigate = useNavigate();
  const { t } = useTranslation();

  console.log("user data", user);

  const toggleTheme = () => {
    dispatch({ type: "TOGGLE_THEME" });
  };

  const handleAvatarClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleMenuClose = () => {
    setAnchorEl(null);
  };
  const handleProfile = () => {
    handleMenuClose();
    navigate("/profile");
  };
  const handleLogout = () => {
    dispatch({ type: "LOGOUT" });
    // Clear all localStorage variables
    localStorage.clear();
    handleMenuClose();
    navigate("/login");
  };

  return (
    <AppBar
      position="fixed"
      sx={{
        borderRadius: "14px",
        ml: { md: `${sidebarWidth + 27}px` },
        width: { md: `calc(100% - ${sidebarWidth + 45}px)` },
        transition: "margin-left 0.3s, width 0.3s",
        top: 0,
        left: 0,
        zIndex: (theme) => theme.zIndex.drawer - 1,
      }}
    >
      <Toolbar sx={{ minHeight: { xs: 48, md: 50 } }}>
        {/* top bar height adjust */}
        <IconButton
          color="inherit"
          aria-label="open drawer"
          edge="start"
          onClick={() => {
            if (isMobile) {
              onMenuClick();
            } else {
              setCollapsed((prev) => !prev);
            }
          }}
          sx={{ mr: 2 }}
        >
          <MenuIcon sx={{ color: theme.palette.text.primary }} />
        </IconButton>

        <Typography
          variant="h6"
          component="div"
          sx={{ flexGrow: 1, color: theme.palette.text.primary }}
        >
          {t("header.greeting")}, {user?.name || "Guest User"}👋🏻
        </Typography>
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <LanguageSelector variant="icon" />
          <IconButton
            color="inherit"
            onClick={toggleTheme}
            aria-label="toggle theme"
          >
            {isDarkMode ? (
              <Brightness7 color="primary" />
            ) : (
              <Brightness4 color="primary" />
            )}
          </IconButton>
          <IconButton onClick={handleAvatarClick} sx={{ ml: 1 }}>
            <Avatar sx={{ width: 32, height: 32 }}>
              {user?.name ? user.name[0].toUpperCase() : "U"}
            </Avatar>
          </IconButton>
          <Menu
            anchorEl={anchorEl}
            open={open}
            onClose={handleMenuClose}
            anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
            transformOrigin={{ vertical: "top", horizontal: "right" }}
          >
            <MenuItem onClick={handleProfile}>{t("common.profile")}</MenuItem>
            <Divider />
            <MenuItem onClick={handleLogout}>{t("common.logout")}</MenuItem>
          </Menu>
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default Header;
